/*
$breakpoints: (
  'small': 460px,
  'medium': 700px,
  'large': 1000px,
  'xlarge': 1300px,
  'xxlarge': 1600px,
);
*/

const matchMedia = {
  data: () => ({
    matchMedia: 'small'
  }),
  methods: {
    $_setMatchMedia () {
      // const intViewportWidth = window.innerWidth;
      if (window.matchMedia("(max-width: 700px)").matches) {
        this.matchMedia= 'small'
      }
      else if (window.matchMedia("(max-width: 1000px)").matches) {
        this.matchMedia= 'medium'
      }
      else if (window.matchMedia("(max-width: 1300px)").matches) {
        this.matchMedia= 'large'
      }
      else if (window.matchMedia("(max-width: 1600px)").matches) {
        this.matchMedia= 'xlarge'
      }
      else {
        this.matchMedia= 'xxlarge'
      }
    }
  },
  mounted(){
    this.$_setMatchMedia()
    window.addEventListener('resize', this.$_setMatchMedia)
  },
  destroyed(){
    window.removeEventListener('resize', this.$_setMatchMedia)
  }
}

export default matchMedia
